import { render, staticRenderFns } from "./CustomerAddModal.vue?vue&type=template&id=6e4fdcbe&scoped=true&"
import script from "./CustomerAddModal.vue?vue&type=script&lang=js&"
export * from "./CustomerAddModal.vue?vue&type=script&lang=js&"
import style0 from "./CustomerAddModal.vue?vue&type=style&index=0&id=6e4fdcbe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4fdcbe",
  null
  
)

export default component.exports